/**
 * Toast component for displaying global error messages
 */

import { useErrorStore, type AppError } from '../../stores/errorStore';
import './Toast.css';

function ToastItem({ error }: { error: AppError }) {
  const { removeError } = useErrorStore();

  const getIcon = () => {
    switch (error.type) {
      case 'network':
        return '📡';
      case 'timeout':
      case 'llm':
        return '⏱️';
      case 'auth':
        return '🔐';
      case 'server':
        return '🔧';
      default:
        return '⚠️';
    }
  };

  return (
    <div className={`toast toast-${error.type}`} role="alert">
      <span className="toast-icon">{getIcon()}</span>
      <div className="toast-content">
        <p className="toast-message">{error.message}</p>
        {error.action && (
          <button
            className="toast-action"
            onClick={error.action.handler}
          >
            {error.action.label}
          </button>
        )}
      </div>
      {error.dismissable && (
        <button
          className="toast-close"
          onClick={() => removeError(error.id)}
          aria-label="Zatvori"
        >
          ×
        </button>
      )}
    </div>
  );
}

export function ToastContainer() {
  const { errors } = useErrorStore();

  if (errors.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite">
      {errors.map((error) => (
        <ToastItem key={error.id} error={error} />
      ))}
    </div>
  );
}

export default ToastContainer;
